module.exports = __webpack_public_path__ + "static/media/contact.42ca8d75.svg";